import { memo, useMemo } from 'react';
import arePropsEqual from 'react-fast-compare';
import { useSelector } from 'react-redux';
import { isEmpty } from 'ramda';
import { Local } from '../../../Local/Local';
import NavigationBlock from '../NavigationBlock';
import NavigationBlockSkeleton from '../NavigationBlock.skeleton';
import { categoryLogoImageSelector } from '../../../../redux/reducers/app/configuration';
import { useQueryCategories } from '../../../../hooks/API/useQueryCategories';
import useIsDesktopLayout from '../../../../hooks/useIsDesktopLayout';
import { categoryToNavItemAdapter } from '../../utils';
import { getCategoriesRoute } from '../../../../utils/routes';
import { createMockEntitiesArray } from '../../../../utils/collectionAdapters';
import { NAMESPACES } from '../../../../constants/namespaces';
import { EVENT_ACTION } from '../../../../constants/ga';
import {
  ANALYTICS_SCHEMA_URLS,
  ANALYTICS_SCREEN_AREA_DETAILS,
} from '../../../../constants/analytics';

const ANALYTICS_DATA_CATEGORY = {
  schema: ANALYTICS_SCHEMA_URLS.MORE_GAME_CLICK,
};

const ANALYTICS_DATA_ALL_CATEGORIES = {
  schema: ANALYTICS_SCHEMA_URLS.ALL_CLASSIFICATION_CLICK,
  screen_area_detail: ANALYTICS_SCREEN_AREA_DETAILS.CATEGORY,
};

const NavigationBlockCategories = ({ limit }) => {
  const { isLoading, data } = useQueryCategories(
    {
      _limit: limit,
    },
    {
      enabled: Boolean(limit),
    }
  );

  const path = useSelector(categoryLogoImageSelector);
  const isDesktop = useIsDesktopLayout();

  const collection = useMemo(() => {
    return isLoading
      ? createMockEntitiesArray(limit)
      : data?.items?.map((category) =>
          categoryToNavItemAdapter(category, path, isDesktop)
        );
  }, [isLoading, data?.items, limit, isDesktop, path]);

  return isLoading ? (
    <NavigationBlockSkeleton />
  ) : !isEmpty(collection) ? (
    <NavigationBlock
      namespace={NAMESPACES.CATEGORY}
      title={<Local namespace={NAMESPACES.NAV}>Categories</Local>}
      titleEventAction={EVENT_ACTION.FILTER_CATEGORIES_ALL}
      showAllLink={getCategoriesRoute()}
      eventItemFieldName="category_id"
      navItems={collection}
      sectionIndex={1}
      analyticsDataItem={ANALYTICS_DATA_CATEGORY}
      analyticsDataAll={ANALYTICS_DATA_ALL_CATEGORIES}
    />
  ) : null;
};

export default memo(NavigationBlockCategories, arePropsEqual);
